import { motion, useReducedMotion } from 'motion/react'
import { ArrowRight, CirclePlay, Guitar, Sparkles, Zap } from 'lucide-react'
import { AppMockup } from '../common/AppMockup'
import type { LandingCopy } from '../../models/LandingPage'
import { trackEvent } from '../../utils/analytics'

type HeroSectionProps = {
  copy: LandingCopy
}

export function HeroSection({ copy }: HeroSectionProps) {
  const words = [copy.hero1, copy.hero2, copy.hero3]
  const reduce = useReducedMotion()

  return <section className="hero"><div className="hero-glow one"/><div className="hero-glow two"/><div className="container hero-grid">
    <motion.div className="hero-copy" initial={{opacity:0,y:reduce?0:24}} animate={{opacity:1,y:0}} transition={{duration:.7}}>
      <div className="eyebrow"><span/><Sparkles size={14}/>{copy.eyebrow}</div>
      <div className="hero-beta-badge"><Zap size={14}/>{copy.heroBadge}</div>
      <h1 aria-label={`${copy.hero1} ${copy.hero2} ${copy.hero3}`}>
        {words.map((word, index) => <motion.span
          key={word}
          initial={{ opacity: 0, y: reduce ? 0 : 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .52, delay: .08 + index * .1 }}
        >{index === 2 ? <em>{word}</em> : word}</motion.span>)}
      </h1>
      <p className="hero-subtitle">{copy.heroSub}</p>
      <p className="hero-explain">{copy.heroExplain}</p>
      <div className="hero-actions"><a className="button" href="#beta" onClick={()=>trackEvent('hero_join_beta_clicked')}>{copy.heroPrimaryCta}<ArrowRight size={17}/></a><a className="button ghost" href="#demo" onClick={()=>trackEvent('hero_demo_clicked')}><CirclePlay size={18}/>{copy.watch}</a></div>
      <div className="hero-hardware"><Guitar size={16}/>{copy.heroHardware}</div>
    </motion.div>
    <motion.div className="hero-product" initial={{opacity:0,x:reduce?0:40,rotateY:reduce?0:-4}} animate={{opacity:1,x:0,rotateY:0}} transition={{duration:.9,delay:.16}}><div className="floating-chip chip-a"><Zap size={16}/> 97% tone match</div><div className="floating-chip chip-b"><Guitar size={16}/> Guitar detected</div><AppMockup compact/></motion.div>
  </div></section>
}
